export default "__VITE_ASSET__BbQShgfQ__"